module.exports = __webpack_public_path__ + "media/images/home-page/2@2x-706a4e8a87358330f71e212b09e12b91.png";